<template>
   <v-dialog
      v-model="value"
      max-width="500"
      persistent
    >
      <v-card class="px-5 py-5">
        <v-progress-linear
          v-model="labelPercent"
          color="amber"
          height="25"
        >{{ labelPercent }}%</v-progress-linear>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    percent: Number,
    final: Number,
    initial: Number,
  },
  computed: {
    labelPercent(){
      if(this.percent)
        return this.percent.toFixed(0)
      else if(this.final && this.initial)
        return ((this.final / this.initial) * 100).toFixed(0)
      else 
        return 0
    }
  }
}
</script>

<style>

</style>